import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import { useState, useEffect } from 'react';

const AboutPage = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const testimonials = [
    {
      text: "Just received my package. Exactly as described, and even included thoughtful extras. I am so pleased. Thank you for the exceptional service!",
      author: "eBay US Buyer"
    },
    {
      text: "Completely reliable and such a wonderful person to work with!",
      author: "eBay US Buyer"
    },
    {
      text: "Great quality and excellent customer service!",
      author: "eBay US Buyer"
    },
    {
      text: "Absolutely the best customer service! Any issues were taken care of promptly and professionally. Thank you so much!",
      author: "eBay US Buyer"
    },
    {
      text: "Great products, love them!",
      author: "eBay US Buyer"
    },
    {
      text: "Stellar customer service as well! Highly recommended!",
      author: "eBay US Buyer"
    },
    {
      text: "Great people to deal with. Thank you!",
      author: "eBay US Buyer"
    },
    {
      text: "Great seller! Accurately graded, very well packaged, arrived quickly. Thanks!",
      author: "eBay US Buyer"
    },
    {
      text: "As described, great communication, highly recommended!",
      author: "eBay US Buyer"
    },
    {
      text: "Never any disappointments, as always! Thank you very much!",
      author: "eBay US Buyer"
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % testimonials.length);
    }, 4000);

    return () => clearInterval(timer);
  }, [testimonials.length]);

  return (
    <div className="min-h-screen bg-white" style={{fontFamily: 'Pretendard, "Noto Sans KR", SUIT, sans-serif'}}>
      <Navigation />
      
      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-7xl md:text-8xl font-extrabold text-black mb-6 leading-tight">
              Our Story
            </h1>
            <p className="text-xl text-gray-600 font-bold tracking-tight" style={{letterSpacing: '-0.02em'}}>
              좋은 브랜드가 세상에 알려지도록
            </p>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="py-32 bg-[#F7F7F7]">
        <div className="container mx-auto px-8">
          <div className="max-w-7xl mx-auto">
            <div className="grid lg:grid-cols-[40%_60%] gap-20 items-start">
              {/* Left Content */}
              <div className="space-y-12">
                <h2 className="text-4xl md:text-6xl font-semibold text-black leading-tight">Why We Started</h2>
                
                <div className="space-y-8">
                  {/* Desktop Text */}
                  <div className="hidden md:block space-y-6 text-lg leading-relaxed font-light text-gray-700" style={{lineHeight: '1.8', fontSize: '18px'}}>
                    <p>
                      한국에는 정말 좋은 뷰티 브랜드가 많습니다.<br />
                      하지만 해외 진출은 여전히 쉽지 않습니다.<br />
                      입점, 물류, CS, 운영 —<br />
                      브랜드사가 준비하실 단계가 참 많습니다.
                    </p>
                    <p>
                      Prime Connect는 그 과정을 대신합니다.<br />
                      브랜드사가 제품에 집중하시는 동안,<br />
                      시장 리서치부터 입점, 리스팅, 운영, CS까지<br />
                      유통에 필요한 전 과정을 실행합니다.
                    </p>
                    <p>
                      우리는 중간에 멈추지 않습니다.<br />
                      실제 매출과 리뷰, 재구매로 이어지는<br />
                      지속 가능한 성장 구조를 만듭니다.
                    </p>
                  </div>
                  
                  {/* Mobile Text */}
                  <div className="block md:hidden space-y-8 text-lg leading-relaxed font-light text-[#555555]" style={{lineHeight: '1.7', fontSize: '17px'}}>
                    <p className="leading-loose">
                      한국에는 정말 좋은 뷰티 브랜드가 많습니다.<br />
                      하지만 해외 진출은 여전히 쉽지 않습니다.
                    </p>
                    <p className="leading-loose">
                      입점, 물류, CS, 운영 —<br />
                      브랜드사가 준비하실 단계가 참 많습니다.
                    </p>
                    <p className="leading-loose">
                      Prime Connect는 그 과정을 대신합니다.<br />
                      브랜드사가 제품에 집중하시는 동안,<br />
                      시장 리서치부터 입점, 리스팅, 운영, CS까지 —<br />
                      유통에 필요한 전 과정을 실행합니다.
                    </p>
                    <p className="leading-loose">
                      우리는 중간에 멈추지 않습니다.<br />
                      실제 매출과 리뷰, 재구매로 이어지는<br />
                      지속 가능한 성장 구조를 만듭니다.
                    </p>
                  </div>
                  
                  {/* Highlighted Slogan */}
                  <div className="relative pl-6 py-8 mt-12">
                    <div className="absolute left-0 top-0 bottom-0 w-1 bg-[#E8A0A0]"></div>
                    <div className="space-y-2">
                      <p className="text-2xl font-bold text-black leading-relaxed">
                        "Execute, Not Just Sell."
                      </p>
                      <p className="text-lg text-gray-700 font-light">
                        — 이것이 우리가 일하는 방식입니다.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Right Image */}
              <div className="relative flex justify-center lg:justify-end">
                <div className="w-full">
                  <img 
                    src="https://static.readdy.ai/image/6046fe4c9f6fc7a4bbdf56f9f58ccfeb/25b1b01b1bb42b742f9a84a9999c9544.jpeg"
                    alt="Prime Connect CEO"
                    className="w-full h-auto object-contain"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Proven Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto text-center">
            <h2 className="text-7xl md:text-8xl font-extrabold text-black mb-16 leading-tight">
              Proven
            </h2>
            
            <div className="grid md:grid-cols-3 gap-12">
              <div className="bg-gray-50 p-8 rounded-lg flex flex-col justify-center items-center text-center">
                <div className="text-4xl font-extrabold text-[#888888] mb-4 leading-tight">
                  Top Rated Seller
                </div>
                
                <p className="text-lg text-gray-500 font-light leading-relaxed">
                  eBay US 판매 3개월 만에 달성
                </p>
              </div>

              <div className="bg-gray-50 p-8 rounded-lg flex flex-col justify-center items-center text-center">
                <div className="text-4xl font-extrabold text-[#888888] mb-4 leading-tight">
                  5.0 / 5.0
                </div>
                
                <p className="text-lg text-gray-500 font-light leading-relaxed">
                  판매자 평점 전 항목
                </p>
              </div>

              <div className="bg-gray-50 p-8 rounded-lg flex flex-col justify-center items-center text-center">
                <div className="text-4xl font-extrabold text-[#888888] mb-4 leading-tight">
                  100%
                </div>
                
                <p className="text-lg text-gray-500 font-light leading-relaxed">
                  Positive Feedback
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Feedback Section */}
      <section className="py-32 bg-[#FAFAFA]">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-7xl md:text-8xl font-extrabold text-black mb-20 text-center leading-tight">
              What Buyers Say
            </h2>
            
            {/* Carousel */}
            <div className="relative overflow-hidden">
              <div 
                className="flex transition-transform duration-700 ease-in-out"
                style={{ transform: `translateX(-${currentSlide * 100}%)` }}
              >
                {testimonials.map((testimonial, index) => (
                  <div key={index} className="w-full flex-shrink-0 px-4 md:px-12">
                    <div className="bg-white p-12 md:p-16 rounded-lg shadow-sm max-w-4xl mx-auto">
                      <p className="text-2xl md:text-3xl text-gray-700 italic leading-relaxed mb-8">
                        "{testimonial.text}"
                      </p>
                      <p className="text-lg text-gray-400 font-light">
                        — {testimonial.author}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            
            {/* Indicators */}
            <div className="flex justify-center gap-3 mt-12">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentSlide(index)}
                  className={`w-3 h-3 rounded-full transition-all duration-300 cursor-pointer ${
                    currentSlide === index ? 'bg-black w-8' : 'bg-gray-300'
                  }`}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;
